import * as React from 'react';
import { CustomSubmitButton, CustomButton, ButtonType } from "soprasteria-ui-library";
import { useAuth } from "../../../../App";
import { ManageReferralApi } from "../../../../api/ManageReferralApi";
import { IReferral } from '../../../../models/IReferral';

interface IReferralClosedButtons {
    referral: IReferral;
    changeSuccessMessage: (message: string) => void;
    changeErrorMessage: (message: string) => void;
    getReferral: (id: number) => void;
}

export const ReferralClosedButtons: React.FunctionComponent<IReferralClosedButtons> = ({ referral, changeSuccessMessage, changeErrorMessage, getReferral }) => {
    const auth = useAuth();
    const api = new ManageReferralApi(auth);

    const [apiCallPending, setApiCallPending] = React.useState<boolean>(false);

    const onReadButtonClick = () => {
        if (referral.referralId) {
            setApiCallPending(true);
            api.markReferralAsRead(referral.referralId, () => {
                changeSuccessMessage("Remissvaret har lästs");
                if (referral.referralId) {
                    getReferral(referral.referralId);
                }
            }, (error) => {
                changeErrorMessage(error);
            }, () => setApiCallPending(false));
        }
    }

    return (
        <>
            {
                referral.unreadResponse || referral.canCopyReferral ?
                    <>
                        {
                            referral.unreadResponse ?
                                <CustomSubmitButton isLoading={apiCallPending} onButtonSubmit={onReadButtonClick}>Markera som läst</CustomSubmitButton>
                                : null
                        }
                        {
                            referral.canCopyReferral ?
                                <CustomButton buttonType={ButtonType.success} buttonText="Kopiera specialistremiss" data-toggle="modal" data-target="#referral-copy-modal" />
                                : null
                        }
                    </>
                    : null
            }
        </>
    )
}